import React, { useEffect } from "react";
import { EmbedProps, EmbedPropsMapTo } from "./Embed.types";

import { MapTo } from "@adobe/aem-react-editable-components";
import { EmbedWrapper } from "./Embed.styles";

export const EmbedEditConfig: any = {
	emptyLabel: "Alelo - Embed Component",
	isEmpty: function (props: EmbedProps) {
		return props.text == null || props.text.trim().length === 0;
	},
};

export const Embed = ({ text, jsCode, aspectRatio }: EmbedProps) => {
	useEffect(() => {
		if (jsCode) {
			const parser = new DOMParser();
			const doc = parser.parseFromString(jsCode, "text/html");
			const scriptTags = doc.querySelectorAll("script");
			const linkTags = doc.querySelectorAll("link");
			const styleTags = doc.querySelectorAll("style");

			let allTags: any[] = [];

			scriptTags.forEach((script) => {
				allTags.push(script.outerHTML);
			});

			linkTags.forEach((link) => {
				allTags.push(link.outerHTML);
			});

			styleTags.forEach((style) => {
				allTags.push(style.outerHTML);
			});

			if (allTags.length) {
				const fragment = document
					.createRange()
					.createContextualFragment(`${allTags.join("")}`);

				const head = document.head;
				head.appendChild(fragment);
			}
		}
	}, [jsCode]);

	return (
		<EmbedWrapper
			aspectRatio={aspectRatio}
			dangerouslySetInnerHTML={{ __html: text }}
		/>
	);
};

MapTo<EmbedPropsMapTo>("alelo/components/content/v1/embed")(
	Embed,
	EmbedEditConfig
);
